// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".uploaded-media-picker--TycnA .portrait-background{filter:blur(8px) brightness(50%);background-size:cover}.folder-thumbnail--RsBvN{width:40px;height:40px;-o-object-fit:cover;object-fit:cover}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"uploaded-media-picker": "uploaded-media-picker--TycnA",
	"folder-thumbnail": "folder-thumbnail--RsBvN"
};
export default ___CSS_LOADER_EXPORT___;
